import React from 'react'

import { Breadcrumbs, DynamicEntityIndex } from '@reactiveonline/reactive_admin_shared-packages'
import GlobalImports from '../shared/GlobalImports'
import { dynamicTableItemRenderer } from '@reactiveonline/reactive_admin_shared-packages/utils'

export default function SubscriptionPayments({ 
  appProps, subscriptionPayments, icon, initialTotalPages, listColumns, breadcrumbs, entityPath, exportPath, selectedColumns, initialCount
}) {

  const filters = [
    {
      key: 'flavour',
      title: 'Flavour',
      type: 'select',
      options: ['Shop', 'Ordering', 'Appointment', 'Travel'].map(item => (
        {
          title: Support.translations.module_names[item.toLowerCase()],
          value: item
        }
      ))
    },
    {
      key: 'capture_method',
      title: ReactiveCore.translations.columns.payment_method,
      type: 'select',
      options: ["Card", "IBAN"].map(item => (
        {
          title: item,
          value: item
        }
      ))
    },
  ]

  const itemRenderer = (item, columns) => {
    return (
      <>
        { columns.map(column => dynamicTableItemRenderer(item, column)) }
      </>
    )
  }

  return (
    <>
      <div className='page-wrapper-header'>
        <div style={{ width: '100%' }}>
          <div className='flex-box items-center content-space-between'>
            <div className='page-header'>
              <i className={ `fa-light ${ icon }`} />
              <h1 className='page-header-title'>
                { Support.translations.subscription_payment.plural }
              </h1>
            </div>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <DynamicEntityIndex
        initialItems={ subscriptionPayments }
        initialTotalPages={ initialTotalPages }
        initialTotalCount={ initialCount }
        entity={ 'subscription_payments' }
        filters={ filters }
        tableHeadings={ selectedColumns }
        itemRenderer={ itemRenderer }
        itemsPath={ entityPath }
        icon={ icon }
        noResourcesTitle={ Support.translations.subscription_payment.noSubscriptionPayments }
        listColumns={ listColumns }
        columnTranslations={ Support.translations.columns }
        exportPath={ exportPath }
        minDateRange={ 730 }
        headline={ Support.translations.subscription_payment.plural }
        initialDatesEmpty
        disableDelete
        disableSearch
        isExportable
        enableDateFilter
        selectAll
        restrictPastDates
      />

      <GlobalImports appProps={ appProps } />
    </>
  )
}
